import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Malindi5";

const Malindi5 = () => {
  const projectId = 53;
  const title = "Malindi City Breeze Gardens(Phase 5)";

  const mapConfig = {
    minZoom: 16,
    zoom: 22,
    bounds: [
      [61.6209, 18.6283],
      [61.6177, 18.6338],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/past-projects/malindi-gardens-phase-5-baolala/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLScwMHMB_E_kpD9c9pUGJCiaPkGtlnS-maEBt9b7DMG8UnSmTw/viewform"
    />
  );
};

export default Malindi5;
